<template>
  <div class="header  py-8 flex  justify-center bg-gray-100">
    <div class="  clearfix text-center rounded-lg ">
      <img src="images/logo.svg" class="block mb-10 mx-auto" style="width:400px" alt="">
      <div>
        <div class="header-menu gap-2 mb-10  p-1 rounded-full">
          <router-link class="menu-item" :to="{name:'pa-home'}">Live TV</router-link>
          <router-link class="menu-item" :to="{name:'pa-videos'}">Latest Programs</router-link>
          <router-link class="menu-item" :to="{name:'pa-entertainment'}">Entertainment</router-link>
          <router-link class="menu-item" :to="{name:'pa-contact'}">Contact Us</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>export default {
  name: 'pa-header'
}
</script>
